import styled from 'react-emotion';
import { getFontFamilyWithFallback } from '@sendwise/font-helpers';

function getHeadingFontSize(isMobile, fontSize, type) {
  const parsedFontSize = parseInt(fontSize);

  if(type === "headingPrimary") {
    return isMobile ? parsedFontSize : parsedFontSize + 12
  }
  if(type === "headingSecondary") {
    return isMobile ? parsedFontSize - 4  : parsedFontSize
  }
  if(type === "headingTertiary") {
    return isMobile ? parsedFontSize - 6 : parsedFontSize - 2
  }
}

function getBodyFontSize(isMobile, fontSize, type) {
  const parsedFontSize = parseInt(fontSize);

  if(type === "bodyPrimary") {
    return isMobile ? parsedFontSize : parsedFontSize + 8
  }
  if(type === "bodySecondary") {
    return isMobile ? parsedFontSize : parsedFontSize + 6
  }
  if(type === "bodyTertiary") {
    return isMobile ? parsedFontSize : parsedFontSize + 4
  }
}

export const Heading = styled('span')(props => ({
  color: props.color,
  fontFamily: getFontFamilyWithFallback(props.font),
  fontSize: getHeadingFontSize(props.isMobile ,props.fontSize, props.type)
}));


export const NormalText = styled('span')(props => ({
  color: props.color,
  fontFamily: getFontFamilyWithFallback(props.font),
  fontSize: getBodyFontSize(props.isMobile ,props.fontSize, props.type)
}));

export const BodyText = styled('span')(props => ({
  color: props.color,
  fontFamily: getFontFamilyWithFallback(props.theme.bodyFont),
  fontSize: props.fontSize || getBodyFontSize(props.isMobile, props.theme.bodyFontSize, props.type),
}));


// WEBPACK FOOTER //
// ./src/js/widgets/StyledComponents.js